module.exports = __webpack_public_path__ + "media/images/photo/plans/places/kyukyoryuchi-6ec7a34cd7e38e529beebae292dc5883.png";